export default "__VITE_PUBLIC_ASSET__c3366d5b__"